import * as React from 'react';

export const NewbuildingBrokerSelfRequestFormWidgetAdapterLazy = React.lazy(() =>
  import('./NewbuildingBrokerSelfRequestFormWidgetAdapter')
    .then(module => ({
      default: module.NewbuildingBrokerSelfRequestFormWidgetAdapter,
    }))
    .catch(
      /* istanbul ignore next */ () => ({
        default: () => null,
      }),
    ),
);
